'use client';

import { LoopPlaceholder } from '@/components/placeholders';
import EmptyPlaceholder from '@/components/placeholders/empty-placeholder';
import { useGetClassResourcesForFreeLesson } from '@/hooks/use-class-resource';
import { useGetBunnyCdnLibraryId } from '@/hooks/use-customer-secret-api';
import { useGetFreeLessonById } from '@/hooks/use-lesson.api';
import { Button } from '@/ui';
import HtmlContent from '@/ui/html-content';
import { Dialog } from '@/components/dialog';
import { useTranslations } from 'next-intl';
import ResourceVideoPlayerFreeLesson from './resourse-video-palyer-free-lesson';

type LessonDetailsModalProps = {
  setIsFreeLessonModalOpen: (isOpen: boolean) => void;
  lessonId: number;
  courseId: number;
  isOpen: boolean;
};

export default function LessonDetailsModal({
  setIsFreeLessonModalOpen,
  lessonId,
  courseId,
  isOpen,
}: LessonDetailsModalProps) {
  const t = useTranslations();
  const { data: lesson, isLoading } = useGetFreeLessonById(lessonId);
  const { data: lessonResources, isLoading: isResourcesLoading } =
    useGetClassResourcesForFreeLesson(courseId, lessonId);
  const { data: bunnyCdnSecret } = useGetBunnyCdnLibraryId();

  const videoResources = lessonResources?.find(
    resource => resource.type === 'VIDEO',
  );

  if (isLoading || isResourcesLoading) {
    return <LoopPlaceholder />;
  }
  if (!lesson || !lessonResources) {
    return <EmptyPlaceholder />;
  }

  return (
    <Dialog
      open={isOpen}
      className="w-full max-w-3xl overflow-y-auto max-h-[70vh] mt-12"
      onOpenChange={(open: boolean) => {
        if (!open) {
          setIsFreeLessonModalOpen(false);
        }
      }}
    >
      <Dialog.Main className="px-12 h-7">
        <Dialog.CloseButton />
        {videoResources ? (
          <div className="mt-8">
            <ResourceVideoPlayerFreeLesson
              resource={videoResources}
              lesson={lesson}
              bunnyCdnLibraryId={bunnyCdnSecret?.secret ?? ''}
            />
          </div>
        ) : (
          <EmptyPlaceholder
            title={t('no-video-available')}
            description={t('no-video-available-description')}
          />
        )}

        <div className="px-4 lg:px-0 mt-6">
          <div className="flex justify-between items-center">
            <Dialog.Title className="text-lg font-semibold lg:text-3xl">
              {lesson?.title}
            </Dialog.Title>
          </div>
          <HtmlContent content={lesson?.description ?? ''} className="mt-8" />
        </div>

        <div className="mt-6 flex justify-end gap-2 border-t pt-4">
          <Button
            onClick={() => setIsFreeLessonModalOpen(false)}
            className="rounded-md bg-gray-100 px-4 py-2 text-sm text-gray-700 hover:bg-gray-200"
          >
            {t('button.close')}
          </Button>
        </div>
      </Dialog.Main>
    </Dialog>
  );
}
